/* eslint-disable multiline-comment-style */
import React, { useEffect } from 'react'
import TableNew, { TableProps } from '@roo/roo/TableNew'
import { useTranslation } from '@sailor/i18n-web'
import { useTableScrollHeight } from '@/common/utils'
import TableEmptyComponent from '@/components/TableEmptyComponent'
import styles from './index.module.less'

/**
 * 前置要求:请在父元素增加样式: style={{ display: 'flex', flexDirection: 'column' }}
 * 增量功能:
 * 分页总数;空数据展示优化; 竖向滚动;容器高度
 *  * */
const CommonTable: React.FC<TableProps<any>> = (props) => {
  const { t } = useTranslation()
  const tableScrollHeight = useTableScrollHeight()
  const { pagination, ...tableProps } = props

  useEffect(() => {
    const tableBodyEle = document.querySelector('.roo-tableNew-body')
    if (!tableBodyEle) return
    // 获取元素的max-height属性值
    const maxHeight = window.getComputedStyle(tableBodyEle).getPropertyValue('max-height')
    if (maxHeight) {
      // 将height属性设置为max-height的值
      tableBodyEle.style.height = maxHeight
    }
  }, [tableScrollHeight])

  return (
    <TableNew
      className={styles.table_container}
      scroll={{ x: 1000, y: tableScrollHeight }}
      emptyComponent={<TableEmptyComponent loading={Boolean(tableProps.loading)} />}
      pagination={
        typeof pagination === 'object' ? {
          pageSizeOptions: [10, 20, 30, 50],
          showTotal: (total) => t('batch_tablie_amount', { total }),
          ...pagination,
        } : pagination
      }
      {...tableProps}
    />
  )
}

export default CommonTable